import type { UnknownAction } from '@reduxjs/toolkit';
import { setSwapStep } from './reducer';

export const isSetSwapRequestSwapAction = (action: UnknownAction): action is ReturnType<typeof setSwapStep> => {
  return setSwapStep.match(action) /*&& (action.payload === 'locking' || action.payload === 'requesting')*/;
};
